import React, { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { ListAdmin } from "./listofAdmin";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string } from "yup";
import { toast } from "react-toastify";

const validationSchema = object().shape({
  username: string()
    .required("User Name is required")
    .matches(
      /^[a-zA-Z0-9_]{4,}$/,
      "Username must be at least 4 characters and contain only letters, numbers, or underscores"
    ),
  last_name: string().required("Last Name is required"),
  first_name: string().required("First Name is required"),
  email: string().email("Invalid email").required("Email is required"),
  mobile_no: string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
  password: string()
    .required("Password is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must be at least 8 characters, include uppercase, lowercase, number, and special character"
    ),
});

export function AddAdmin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState("");

  const formik = useFormik({
    initialValues: {
      username: "",
      first_name: "",
      last_name: "",
      email: "",
      user_type: "admin",
      mobile_no: "",
      is_active: true,
      password: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          username: values.username.trim(),
          first_name: values.first_name.trim(),
          last_name: values.last_name.trim(),
          email: values.email.trim(),
          mobile_no: values.mobile_no,
          user_type: "admin",
          is_active: true,
          password: values.password,
        };

        const response = await axiosInstance.post(
          "/admin/admin-list/",
          payload
        );

        if (response.data.status === "success") {
          toast.success("Admin added successfully!");
          setTimeout(() => navigate("/manage-admin"), 1500);
        } else {
          alert(response.data.message || "Failed to add admin.");
          toast.error("Something went wrong. Please try again.");
        }
      } catch (err) {
        console.error("❌ Error posting admin:", err);

        const apiMessage =
          err.response?.data?.message ||
          "Something went wrong. Please try again.";

        // Friendly error mapping
        if (
          apiMessage.includes("already exists") &&
          apiMessage.includes("Email")
        ) {
          setServerError(
            "This email is already registered. Please use a different email."
          );
          toast.error(
            "This email is already registered. Please use a different email."
          );
        } else if (
          apiMessage.includes("already exists") &&
          (apiMessage.includes("mobile") || apiMessage.includes("phone"))
        ) {
          setServerError(
            "This mobile number is already registered. Please use a different number."
          );
          toast.error(
            "This mobile number is already registered. Please use a different number."
          );
        } else {
          setServerError(apiMessage);
          toast.error(apiMessage);
        }
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    navigate("/manage-admin");
  };

  return (
    <div className="addAdmin-container">
      <div className="addAdmin-subcontainer">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/manage-admin")}
        />
        <div className="add-title">Add Admin</div>
      </div>
      {/* <div className="note-section-password">
        <p>
          <strong>Note:</strong> When an admin user is created, the default
          password will be set to <strong>GomakAdmin@123</strong>. Please advise
          the user to change it after first login.
        </p>
      </div> */}
      <form onSubmit={formik.handleSubmit}>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> User Name
              </label>
              <div>
                <input
                  type="text"
                  name="username"
                  placeholder="Enter Your User Name"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.username && formik.errors.username && (
                  <div className="text-danger">{formik.errors.username}</div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Last Name
              </label>
              <div>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Enter Your Last Name"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.last_name && formik.errors.last_name && (
                  <div className="text-danger">{formik.errors.last_name}</div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Mobile Number
              </label>
              <div>
                <input
                  type="text"
                  name="mobile_no"
                  placeholder="Enter Your Mobile Number"
                  value={formik.values.mobile_no}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.mobile_no && formik.errors.mobile_no && (
                  <div className="text-danger">{formik.errors.mobile_no}</div>
                )}
              </div>
            </div>
          </div>
          <div className="addAdmin-contentRight">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> First Name
              </label>
              <div>
                <input
                  type="text"
                  name="first_name"
                  placeholder="Enter Your First Name"
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.first_name && formik.errors.first_name && (
                  <div className="text-danger">{formik.errors.first_name}</div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Email
              </label>
              <div>
                <input
                  type="text"
                  name="email"
                  placeholder="Enter Your Email id"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="text-danger">{formik.errors.email}</div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Password
              </label>
              <div>
                <input
                  type="text"
                  name="password"
                  placeholder="Enter Your Password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.password && formik.errors.password && (
                  <div className="text-danger">{formik.errors.password}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        {serverError && (
          <div className="text-danger" style={{ margin: "10px 0" }}>
            {serverError}
          </div>
        )}
        <div className="addbtnContainer">
          <div>
            <button
              type="button"
              className="admin-btnCancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
          <div>
            <button className="add-btnSave" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
